import React from 'react';

import { SVGComponentProps } from './svg.types';

const EmojiSmileSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span id="skull" className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="56"
        height="60"
        viewBox="0 0 56 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_219_17145)">
          <mask id="path-1-inside-1_219_17145" fill="white">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M56 16C56 7.16344 48.8366 0 40 0H16C7.16344 0 0 7.16344 0 16V32C0 47.464 12.536 60 28 60C43.464 60 56 47.464 56 32V16Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M56 16C56 7.16344 48.8366 0 40 0H16C7.16344 0 0 7.16344 0 16V32C0 47.464 12.536 60 28 60C43.464 60 56 47.464 56 32V16Z"
            fill="#EEF1FC"
          />
          <path
            d="M16 3H40V-3H16V3ZM3 32V16H-3V32H3ZM28 57C14.1929 57 3 45.8071 3 32H-3C-3 49.1208 10.8792 63 28 63V57ZM53 32C53 45.8071 41.8071 57 28 57V63C45.1208 63 59 49.1208 59 32H53ZM53 16V32H59V16H53ZM40 3C47.1797 3 53 8.8203 53 16H59C59 5.50659 50.4934 -3 40 -3V3ZM16 -3C5.50659 -3 -3 5.50659 -3 16H3C3 8.8203 8.8203 3 16 3V-3Z"
            fill="#FFDC98"
            mask="url(#path-1-inside-1_219_17145)"
          />
          <path
            d="M16 3H40V-3H16V3ZM3 32V16H-3V32H3ZM28 57C14.1929 57 3 45.8071 3 32H-3C-3 49.1208 10.8792 63 28 63V57ZM53 32C53 45.8071 41.8071 57 28 57V63C45.1208 63 59 49.1208 59 32H53ZM53 16V32H59V16H53ZM40 3C47.1797 3 53 8.8203 53 16H59C59 5.50659 50.4934 -3 40 -3V3ZM16 -3C5.50659 -3 -3 5.50659 -3 16H3C3 8.8203 8.8203 3 16 3V-3Z"
            fill="url(#paint0_linear_219_17145)"
            mask="url(#path-1-inside-1_219_17145)"
          />
          <circle cx="28" cy="28" r="16.6944" fill="#EEF1FC" />
          <circle cx="28" cy="28" r="16.6944" fill="url(#paint1_linear_219_17145)" />
          <circle cx="28" cy="28" r="16.6944" stroke="#E5E9FB" strokeWidth="1.38889" />
          <path
            d="M31.0946 32.2145C30.6294 32.5374 30.1272 32.8019 29.5989 33.0023C28.8044 33.2781 27.9545 33.3488 27.1261 33.2081C26.2978 33.0673 25.5173 32.7196 24.8555 32.1964C24.7118 32.0839 24.547 32.002 24.3711 31.9557C24.1952 31.9095 24.0118 31.8997 23.8321 31.9271C23.6523 31.9545 23.48 32.0185 23.3253 32.1151C23.1707 32.2118 23.0371 32.3391 22.9325 32.4895C22.8279 32.6398 22.7545 32.8101 22.7168 32.9899C22.6791 33.1698 22.6778 33.3555 22.713 33.5358C22.7482 33.7162 22.8192 33.8874 22.9217 34.0393C23.0241 34.1911 23.156 34.3204 23.3092 34.4192C24.6749 35.4213 26.3128 35.9734 27.9999 36.0003C29.6653 35.977 31.2838 35.4387 32.6378 34.4576C32.7979 34.3639 32.9372 34.2379 33.047 34.0874C33.1568 33.9369 33.2349 33.7651 33.2762 33.5828C33.3175 33.4005 33.3213 33.2115 33.2873 33.0276C33.2532 32.8437 33.1821 32.6689 33.0784 32.5141C32.9708 32.3585 32.833 32.2268 32.6734 32.1269C32.5139 32.027 32.3358 31.961 32.1502 31.933C31.9646 31.9049 31.7752 31.9154 31.5938 31.9638C31.4123 32.0122 31.2425 32.0975 31.0946 32.2145Z"
            fill="#627FE5"
          />
          <path
            d="M23.6897 24.1362C23.7192 23.1916 23.7213 22.246 23.6897 21.3014C23.6852 21.1239 23.6457 20.9492 23.5734 20.7874C23.5011 20.6257 23.3975 20.4802 23.2687 20.3597C23.1398 20.2391 22.9884 20.1459 22.8234 20.0855C22.6584 20.0252 22.483 19.9989 22.3078 20.0082C21.9615 20.011 21.6303 20.1523 21.3866 20.4011C21.1429 20.65 21.0065 20.9863 21.007 21.3366C20.9912 21.7886 21.007 22.2417 21.007 22.6948C21.007 23.1479 20.9954 23.6266 21.007 24.0925C21.0052 24.2693 21.0379 24.4447 21.1031 24.6087C21.1684 24.7727 21.2649 24.9221 21.3873 25.0483C21.5097 25.1746 21.6554 25.2752 21.8163 25.3444C21.9771 25.4136 22.1498 25.4501 22.3246 25.4518C22.4997 25.4562 22.6739 25.4256 22.8373 25.3619C23.0007 25.2981 23.15 25.2024 23.2768 25.0802C23.4036 24.958 23.5053 24.8118 23.5761 24.6498C23.647 24.4878 23.6856 24.3133 23.6897 24.1362Z"
            fill="#627FE5"
          />
          <path
            d="M34.9944 21.3722C34.996 21.1937 34.9629 21.0166 34.8969 20.851C34.8309 20.6854 34.7333 20.5346 34.6097 20.4072C34.486 20.2798 34.3388 20.1783 34.1764 20.1084C34.014 20.0386 33.8395 20.0017 33.6631 20.0001C33.4866 19.9984 33.3115 20.0319 33.1478 20.0986C32.9841 20.1654 32.835 20.2641 32.709 20.3891C32.4546 20.6417 32.3098 20.9861 32.3065 21.3466C32.2833 22.2649 32.2833 23.1831 32.3065 24.1014C32.3179 24.4553 32.4653 24.7907 32.7175 25.0362C32.9696 25.2818 33.3065 25.4182 33.6565 25.4164C34.0066 25.4146 34.3421 25.2747 34.5917 25.0266C34.8414 24.7784 34.9854 24.4415 34.9933 24.0876C35.007 23.6355 34.9933 23.1824 34.9933 22.7304C34.9933 22.2784 35.007 21.821 34.9944 21.3722Z"
            fill="#627FE5"
          />
          <path
            d="M25.7969 29.5167C26.1152 29.5391 26.4346 29.5391 26.7529 29.5167C26.793 29.5167 26.8288 29.5295 26.8699 29.5252C27.5148 29.4151 28.106 29.0936 28.5524 28.6103C28.9989 28.1269 29.2759 27.5085 29.3407 26.8503C29.3555 25.0273 29.3502 23.2042 29.3407 21.3811C29.343 21.1999 29.3095 21.02 29.242 20.8521C29.1746 20.6842 29.0746 20.5316 28.9479 20.4034C28.8213 20.2752 28.6705 20.1739 28.5045 20.1055C28.3386 20.0371 28.1608 20.003 27.9816 20.0052C27.8024 20.0074 27.6255 20.0459 27.4612 20.1183C27.2969 20.1908 27.1486 20.2957 27.0251 20.427C26.9016 20.5583 26.8053 20.7133 26.7419 20.8829C26.6785 21.0524 26.6493 21.233 26.656 21.4142C26.656 23.1957 26.656 24.9782 26.656 26.7906H26.6317C26.3218 26.7821 26.2101 26.7832 25.8243 26.7906C25.4669 26.7869 25.1227 26.927 24.8674 27.18C24.6121 27.4331 24.4666 27.7783 24.463 28.1398C24.4593 28.5013 24.5978 28.8495 24.848 29.1077C25.0981 29.3659 25.4395 29.513 25.7969 29.5167Z"
            fill="#627FE5"
          />
          <mask
            id="mask0_219_17145"
            // style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="56"
            height="60"
          >
            <mask id="path-8-inside-2_219_17145" fill="white">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M56 8C56 3.58172 52.4183 0 48 0H8C3.58172 0 0 3.58172 0 8V32C0 47.464 12.536 60 28 60C43.464 60 56 47.464 56 32V8Z"
              />
            </mask>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M56 8C56 3.58172 52.4183 0 48 0H8C3.58172 0 0 3.58172 0 8V32C0 47.464 12.536 60 28 60C43.464 60 56 47.464 56 32V8Z"
              fill="#FFF3E5"
            />
            <path
              d="M8 3H48V-3H8V3ZM3 32V8H-3V32H3ZM28 57C14.1929 57 3 45.8071 3 32H-3C-3 49.1208 10.8792 63 28 63V57ZM53 32C53 45.8071 41.8071 57 28 57V63C45.1208 63 59 49.1208 59 32H53ZM53 8V32H59V8H53ZM48 3C50.7614 3 53 5.23858 53 8H59C59 1.92487 54.0751 -3 48 -3V3ZM8 -3C1.92487 -3 -3 1.92487 -3 8H3C3 5.23858 5.23858 3 8 3V-3Z"
              fill="#EDC474"
              mask="url(#path-8-inside-2_219_17145)"
            />
          </mask>
          <g mask="url(#mask0_219_17145)">
            <rect
              opacity="0.2"
              x="-4.68457"
              y="47.6843"
              width="80"
              height="20"
              transform="rotate(-45 -4.68457 47.6843)"
              fill="white"
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_219_17145"
            x1="-31"
            y1="-9"
            x2="87.412"
            y2="45.2338"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#254DDA" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_219_17145"
            x1="42.6667"
            y1="62"
            x2="28"
            y2="2.66667"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#254DDA" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <clipPath id="clip0_219_17145">
            <rect width="56" height="60" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export default EmojiSmileSVG;
